import { combineReducers } from "redux";
import atgGamesSlice from "./atgGames/atgGamesSlice";
import betWinSlice from "./betWinData/betWinSlice";
import boostingSlice from "./boosting/boostingSlice";
import broadcastsSlice from "./broadcasts/broadcastsSlice";
import gameplaySlice from "./gameplay/gameplaySlice";
import guoZhaoSlice from "./guoZhao/guoZhaoSlice";
import lobbiesSlice from "./lobbies/lobbiesSlice";
import lobbyMachinesSlice from "./lobbyMachines/lobbyMachinesSlice";
import rsgGamesSlice from "./rsgGames/rsgGamesSlice";
import scoreMsgSlice from "./scoreMsg/scoreMsgSlice";
import switchFuncSlice from "./switchFunc/switchFuncSlice";
import switchPageSlice from "./switchPage/switchPageSlice";
import userCoinsSlice from "./userCoins/userCoinsSlice";

const allReducers = combineReducers({
  switchFunc: switchFuncSlice.reducer,
  lobbies: lobbiesSlice.reducer,
  broadcasts: broadcastsSlice.reducer,
  userCoins: userCoinsSlice.reducer,
  scoreMsg: scoreMsgSlice.reducer,
  lobbyMachines: lobbyMachinesSlice.reducer,
  gameplay: gameplaySlice.reducer,
  betWin: betWinSlice.reducer,
  boosting: boostingSlice.reducer,
  guoZhao: guoZhaoSlice.reducer,
  switchPage: switchPageSlice.reducer,
  atgGames: atgGamesSlice.reducer,
  rsgGames: rsgGamesSlice.reducer,
});

export default allReducers;
